import { render, staticRenderFns } from "./addProject.vue?vue&type=template&id=5cae1b1f&scoped=true"
import script from "./addProject.vue?vue&type=script&lang=js"
export * from "./addProject.vue?vue&type=script&lang=js"
import style0 from "./addProject.vue?vue&type=style&index=0&id=5cae1b1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cae1b1f",
  null
  
)

export default component.exports